<app-navbar
  *ngIf="isAuthenticated"
  (signOutEmitter)="signOut()"
  [email]="email"
  [user]="user"
  [isAuthenticated]="isAuthenticated"
>
</app-navbar>

<div class="landing-header">
  <h1 class="landing-title">Application Portals</h1>
</div>

<div *ngIf="loading" class="loading-container">
  <p>Loading applications...</p>
</div>

<div
  *ngIf="!loading && (loadingError || applicationsLoadFailed)"
  class="error-container"
>
  <p>
    Could not load applications. Please refresh the page or contact support if
    the issue persists.
  </p>
</div>

<div
  class="tile-grid"
  *ngIf="!loading && !loadingError && !applicationsLoadFailed"
>
  <div class="tile" *ngFor="let tile of tiles">
    <div class="tile-content">
      <h3 class="tile-title">{{ tile.title }}</h3>
      <p class="tile-description">{{ tile.description }}</p>
    </div>

    <div class="tile-footer">
      <button (click)="onTileClick(tile)" class="tile-link" type="button">
        <span>Access</span>
      </button>
    </div>
  </div>
</div>

<div
  *ngIf="
    !loading && !loadingError && !applicationsLoadFailed && tiles.length === 0
  "
  class="no-tiles-container"
>
  <p>No applications available. Please contact your administrator.</p>
</div>
